import "./PrintReport.scss";
import React, {useRef, useEffect, useState} from 'react';
import { withRouter } from "../../helpers/withRouter";
import Storage from "../../helpers/Storage";
import ComboBox from "../../shared/component/ComboBox/ComboBox2";
import { _loading } from "../../actions/Loading";
import {connect, useDispatch} from "react-redux";
import Header from "../Panel/Header/header";
import Footer from "../Panel/Footer/footer";
import Button from "../../shared/component/button/Button";
import T from "../../shared/component/t/T";
import {default as _} from "../../helpers/Translate";
import User from "../../core/api/User2/User";

const userLog = new User()

function PrintReport(props) {
    const dispatch = useDispatch();
    const [direction] = useState(Storage.directionGet());
    const [headerItems, setHeaderItems] = useState([]);
    const [selectedHeader, setSelectedHeader] = useState(3);
    const [sizeItems, setSizeItems] = useState([]);
    const [selectedSize, setSelectedSize] = useState();
    const [url, setUrl] = useState("");
    const [logID, setLogID] = useState();
    const printRef  = useRef()

    useEffect(() => {
        Storage.addNewVisitedRowIDs(props.params.studyID, props.params.reportID)
        document.title = _.init("title_printPage");
        dispatch(_loading(true));
        setSelectedSize(Storage.getUserFontSize())
        initHeaderComboes()
        initSizeComboes()
        handleLoad()
    },[]);

    useEffect(() => {
        if (selectedSize && selectedHeader){
            initPageContents()
        }
    },[selectedHeader, selectedSize]);

    useEffect(() => {
        let localSize = Storage.getUserFontSize()
        if (selectedSize && selectedSize !== localSize) Storage.setUserFontSize(selectedSize)
    },[selectedSize]);

    const initHeaderComboes=() => {
        let comboList = []
        Storage.getReportHeaders().forEach(e => {
            comboList = [...comboList, {id: e.id, text: e.title, value: e.id}]
        })
        setHeaderItems(comboList)
    }

    const initSizeComboes=()=> {
        let comboList = []
        for (let i = 10; i <= 24; i = i + 2) {
            comboList = [...comboList, { id: i, text: i, value: i }]
        }
        setSizeItems(comboList)
    }

    const initPageContents = () => {
        setUrl(`1/report?id=${props.params.reportID}&study_id=${props.params.studyID}&header_id=${selectedHeader}&font_size=${selectedSize}`)
    }

    const handleLoad = () =>{
        const pdf_viewer = document.querySelector(".pdf_viewer");
        const iframe = document.querySelector("iframe");
        if (pdf_viewer && iframe){
            const height = Math.max(pdf_viewer.getBoundingClientRect().height - 12, iframe.getBoundingClientRect().height);
            iframe.style.height = `${height}px`
        }
    }
	
	const createLog = () => {
		userLog.userLogCreate({
		      action: 22,
		      studyID: props.params.studyID,
		      path: url
	    }).then(response => {
			setLogID(response?.data.user_log.id)
	    }).catch(error => console.log(error));
	}
	
	const updateLog = () => {
		userLog.userLogUpdate({
	      userLogID: logID,
	    }).then(() => {
	    }).catch(error =>
	        console.error(error)
	    ).finally(() => {
	    });
	}
    const print = () => {
        !logID ? createLog() : updateLog()
        document.getElementById("printablediv").contentWindow.print();
    }

    const loaded = () => {
        dispatch(_loading(false));
    }

    return (
        <>
            <Header
                calssName="hide-on-print"
                page={"print"}
            />
            <div className={'print'} style={{direction}}>
                <div className={"buttons"}>
                    <div className={"buttons__font_size"}>
                        <ComboBox
                            type="select"
                            labelText="font_size"
                            comboboxValues={sizeItems}
                            nonTransparent
                            fieldName="font_size"
                            changeValueHandler={value => setSelectedSize(value)}
                            selectedItem={selectedSize}
                        />
                    </div>

                    <div className={"buttons__header"}>
                        <ComboBox
                            type="select"
                            labelText="report_header"
                            comboboxValues={headerItems}
                            nonTransparent
                            fieldName="report_header"
                            changeValueHandler={value => setSelectedHeader(value)}
                            selectedItem={selectedHeader}
                        />
                    </div>

                    <div className={"buttons__header"}>
                        <Button className={"report_search"} size="small" customClasses="margin-2px" mode="gray-new" key={2}
                                onClick={print} >
                            <T token={"print"} />
                        </Button>
                    </div>

                </div>

                <div className={`pdf_viewer`}>
                    <iframe id="printablediv" title={"print"} ref={printRef} className="Print" src={url} onLoad={loaded}/>
                </div>
            </div>
            <Footer/>
        </>
    );
}


const mapStateToProps = state => {
    const language = state.LangReducer.language;
    return {language};
};

export default connect(mapStateToProps)(withRouter(PrintReport));